import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkEditPanel = ({ selectedCount, onBulkUpdate, onClearSelection }) => {
  const [bulkField, setBulkField] = useState('');
  const [bulkValue, setBulkValue] = useState('');

  const handleApplyBulk = () => {
    if (bulkField && bulkValue) {
      const value = bulkField === 'price' ? parseFloat(bulkValue) : bulkValue;
      onBulkUpdate(bulkField, value);
      setBulkField('');
      setBulkValue('');
    }
  };

  return (
    <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon name="CheckSquare" size={20} color="var(--color-accent)" />
          <span className="text-sm font-semibold text-foreground">
            {selectedCount} plat{selectedCount > 1 ? 's' : ''} sélectionné{selectedCount > 1 ? 's' : ''}
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearSelection}
          iconName="X"
          iconSize={16}
        >
          Désélectionner
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        <select
          value={bulkField}
          onChange={(e) => setBulkField(e?.target?.value)}
          className="px-3 py-2 border border-input rounded-md text-sm bg-background"
        >
          <option value="">Sélectionner un champ</option>
          <option value="price">Prix</option>
          <option value="category">Catégorie</option>
        </select>

        {bulkField === 'price' && (
          <input
            type="number"
            step="0.01"
            value={bulkValue}
            onChange={(e) => setBulkValue(e?.target?.value)}
            placeholder="Nouveau prix"
            className="px-3 py-2 border border-input rounded-md text-sm"
          />
        )}

        {bulkField === 'category' && (
          <select
            value={bulkValue}
            onChange={(e) => setBulkValue(e?.target?.value)}
            className="px-3 py-2 border border-input rounded-md text-sm bg-background"
          >
            <option value="">Sélectionner une catégorie</option>
            <option value="appetizers">Entrées</option>
            <option value="mains">Plats principaux</option>
            <option value="desserts">Desserts</option>
            <option value="beverages">Boissons</option>
          </select>
        )}

        <Button
          onClick={handleApplyBulk}
          disabled={!bulkField || !bulkValue}
          size="sm"
          iconName="Check"
          iconPosition="left"
        >
          Appliquer
        </Button>
      </div>
    </div>
  );
};

export default BulkEditPanel;